import { CatRadioField } from 'blocks-nextjs/blocks-react/components/RadioField';
import { useTranslations } from 'next-intl';
import { CatIconStarFilled } from 'blocks-nextjs/blocks-react/components/Icons/StarFilled';
import SavedListTableTypeCell from '../custom-cells/saved-list-table-type-cell/saved-list-table-type-cell';
import SavedListTableMobileCell from '../custom-cells/saved-list-table-mobile-cell';
import SavedListTableLinkCell from '../custom-cells/saved-list-table-link-cell';
import styles from '../../saved-list-drawer.module.scss';
import cx from 'classnames';

const dateSortingFn = (a, b) => {
  const firstDate = new Date(a.original.createdOrLastUpdatedDate.formattedDate);
  const secondDate = new Date(
    b.original.createdOrLastUpdatedDate.formattedDate
  );

  if (firstDate > secondDate) {
    return 1;
  } else if (firstDate < secondDate) {
    return -1;
  }

  return 0;
};

export const useSavedListColumn = (
  isCsp,
  isMobile = false,
  savedListDetailFeatureFlag = false
) => {
  const t = useTranslations();
  const nameFavouriteAndQuantity = [
    {
      accessorKey: 'name',
      header: () => t('MA_NAME'),
      cell: (info) => {
        return (
          <div className="d-flex align-items-center">
            <CatRadioField
              value={info?.row?.original?.shoppingListId?.toString() || ''}
              name="radio-saved-list"
              hideLabel
              checked={info?.row?.getIsSelected() || false}
              onBlRadioChange={info?.row?.getToggleSelectedHandler()}
            />
            <p
              className={cx(
                'mb-0 ps-2',
                styles['saved-list-drawer__body--name']
              )}
            >
              {info?.row?.original?.name || ''}
            </p>
          </div>
        );
      },
      meta: {
        sort: 'descending'
      }
    },
    {
      accessorKey: 'favourite',
      header: () => '',
      cell: (info) =>
        info?.row?.original?.isFavorite && (
          <CatIconStarFilled
            color="knockout-brand"
            data-testid="cat-icon-star"
          />
        ),
      meta: {
        width: '77px'
      }
    },
    {
      accessorKey: 'orderItemsQuantity',
      header: () => t('REQUISITIONLIST_QUANTITY'),
      cell: (info) => info?.getValue() ?? '',
      meta: {
        width: '109px'
      }
    }
  ];

  if (isMobile) {
    return [
      {
        accessorKey: 'mobileColumn',
        header: () => '',
        cell: (info) => {
          return (
            <SavedListTableMobileCell
              info={info}
              isCspUser={isCsp}
              savedListDetailFeatureFlag={savedListDetailFeatureFlag}
            />
          );
        }
      }
    ];
  }

  if (isCsp) {
    return [
      ...nameFavouriteAndQuantity,
      {
        accessorKey: 'createdBy',
        header: () => t('REQUISITIONLIST_CREATOR'),
        cell: (info) => info.getValue(),
        meta: {
          width: '434px',
          sort: 'descending'
        }
      },
      {
        accessorKey: 'updated',
        header: () => t('REQUISITIONLIST_UPDATED'),
        cell: (info) =>
          info?.row?.original?.createdOrLastUpdatedDate?.unformattedDate
            ?.split(' ')
            ?.splice(0, 3, '')
            ?.join(' ') || '',
        meta: {
          width: '147px',
          sort: 'ascending'
        },
        sortingFn: dateSortingFn
      },
      {
        accessorKey: 'listType',
        header: () => t('REQUISITIONLIST_TYPE'),
        cell: (info) => (
          <SavedListTableTypeCell type={info?.row?.original?.type} />
        ),
        meta: {
          width: '118px',
          sort: 'descending'
        }
      },
      {
        accessorKey: 'viewList',
        header: () => t('QO_SAVEDLIST_VIEWLIST'),
        cell: (info) => (
          <SavedListTableLinkCell
            info={info}
            savedListDetailFeatureFlag={savedListDetailFeatureFlag}
          />
        ),
        meta: {
          width: '93px'
        }
      }
    ];
  }

  return [
    ...nameFavouriteAndQuantity,
    {
      accessorKey: 'updated',
      header: () => t('REQUISITIONLIST_UPDATED'),
      cell: (info) =>
        info?.row?.original?.createdOrLastUpdatedDate?.unformattedDate
          ?.split(' ')
          ?.splice(0, 3, '')
          ?.join(' ') || '',
      meta: {
        width: '147px',
        sort: 'ascending'
      },
      sortingFn: dateSortingFn
    },
    {
      accessorKey: 'viewList',
      header: () => t('QO_SAVEDLIST_VIEWLIST'),
      cell: (info) => (
        <SavedListTableLinkCell
          info={info}
          savedListDetailFeatureFlag={savedListDetailFeatureFlag}
        />
      ),
      meta: {
        width: '93px'
      }
    }
  ];
};
